import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import Background from '@/components/Background.vue';
import VariableLogo from '@/components/VariableLogo.vue';
import Snackbar from '@/components/Snackbar.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import BeeInput from '@/components/BeeInput.vue';
import WhatsApp from '@/components/WhatsAppButtom.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import CounterButton from '@/components/CounterButton.vue';
import Modal from '@/components/Modal.vue';
import { PaymentMethod, StatusDelivery } from '../models/Order';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import ThankYouOrderModal from '@/components/ThankYouOrderModal.vue';
import DoubleConfirmFinishOrder from '@/components/DoubleConfirmFinishOrder.vue';
import { formatPrice } from '@/mixins/MenuLocalization';
import OrderService from '@/services/OrderService';
import { TypePayment } from '@/models/TypePayment';
import axios from 'axios';
import { PaymentDetails, PaymentStatus } from '@/models/PaymentDetails';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import auth from '@/config/auth';
import Customer from '@/models/PaymentGateway/Customer';
import { isOpen } from '@/utils/ScheduleUtils';
import { loadStripe } from '@stripe/stripe-js';
import { ApiErrors } from '@/models/PaymentGateway/ApiErrors';
import AddressService from '@/services/AddressService';
import { TypeOrder } from '@/store/state';
import firebase from 'firebase';
import { getDeliveryCost } from '@/utils/MapsUtils';
let SummaryDelivery = class SummaryDelivery extends Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.phone = '';
        this.date = '';
        this.hour = '';
        this.address = '';
        this.methodPayment = '';
        this.cashInfo = '';
        this.totaltext = '';
        this.cashInfoError = false;
        this.excessCash = false;
        this.visa = false;
        this.deliveryCost = 0;
        this.americanExpress = false;
        this.mastercard = false;
        this.cardActive = false;
        this.cashActive = false;
        this.onlineActive = false;
        this.transferActive = false;
        this.onlinePaymentActive = this.$store.state.deliveryMenu.onlinePayment;
        this.paymentActive = this.$store.state.deliveryMenu.payment.online.active;
        this.conektaActive = this.$store.state.deliveryMenu.payment.online.conekta;
        this.nameRestaurant = '';
        this.dateNow = new Date();
        this.modalForm = false;
        this.displayDivCard = false;
        this.displayDivCash = true;
        this.displayDivTransfer = false;
        this.displayDivConketa = false;
        this.hideButtons = true;
        this.showWhats = true;
        this.order = this.$store.state.order;
        this.menu = this.$store.state.menu;
        this.thumbnailBorder = `border: 1px ${this.$store.getters.colors.backgroundColor} solid;`;
        this.goodEnding = false;
        this.loading = false;
        this.delivery = this.$store.state.deliveryMenu;
        this.openRestaurant = true;
        this.hideModal = true;
        this.schedule = undefined;
        this.scheduleInitDay = '';
        this.scheduleEndDay = '';
        this.showThanks = false;
        this.showDoubleConfirm = false;
        this.deliveryEstimate = '';
        this.user = this.$store.state.user;
        this.checkedTabs = false;
        this.cardDetails = {
            cardName: '',
            cardNumber: '',
            cardExpiry: '',
            cardCvc: ''
        };
        this.cardErrors = {
            cardName: false,
            cardNumber: false,
            cardExpiry: false,
            cardCvc: false
        };
        this.messageToPurchaser = '';
        this.customer = undefined;
        this.token = '';
        this.conektaReady = true;
        this.stripeReady = true;
        this.processingPayment = false;
        this.stripe = null;
        this.completeForm = false;
        this.cardData = true;
        this.cardElement = null;
        this.addressDefault = false;
        this.addressDefaultData = undefined;
        this.withoutAddress = false;
        this.canOrder = false;
    }
    goLocation() {
        this.$router.push('/locations');
    }
    get orderSent() {
        if (this.order && this.order.sent)
            return true;
        return false;
    }
    get readableId() {
        if (this.order?.number) {
            return '#' + this.order.number;
        }
        return '';
    }
    hideForm() {
        this.hideModal = true;
        const active = this.$store.state.deliveryMenu.shipping;
        if (active === false || !this.openRestaurant) {
            this.$router.push(`/${this.menu?.restaurantId}/${this.menu?.id}`);
        }
    }
    async displayDoubleConfirm() {
        this.loading = true;
        if (this.order && this.addressDefault) {
            if (this.methodPayment === PaymentMethod.CASH) {
                if (this.cashInfo != '') {
                    if (this.order.total > 2000) {
                        this.excessCash = true;
                        this.cashInfoError = false;
                        this.loading = false;
                    }
                    else {
                        this.showDoubleConfirm = true;
                        this.loading = false;
                    }
                }
                else {
                    this.cashInfoError = true;
                    this.loading = false;
                }
            }
            if (this.methodPayment === PaymentMethod.ONLINE) {
                if (this.completeForm) {
                    this.cardData = true;
                    await this.getStripePaymentMethod();
                }
                else {
                    this.cardData = false;
                    this.loading = false;
                }
            }
        }
        else {
            this.loading = false;
            this.withoutAddress = true;
        }
    }
    async displayThanks() {
        const delivery = this.$store.state.deliveryMenu;
        if (delivery) {
            if (delivery.schedule) {
                this.schedule = delivery.schedule;
            }
            if (this.menu) {
                this.loading = true;
                this.openRestaurant = await isOpen(this.menu.id);
                this.loading = false;
            }
        }
        if (this.openRestaurant) {
            this.showDoubleConfirm = false;
            this.showThanks = true;
            setTimeout(() => {
                this.closeShowThanks();
            }, 1500);
        }
        else {
            this.openRestaurant = false;
            this.loading = false;
        }
    }
    closeShowThanks() {
        this.showThanks = false;
        this.sendForm();
    }
    onlyNumber($event) {
        const keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57) {
            $event.preventDefault();
        }
    }
    monthYear($event) {
        const keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57) {
            $event.preventDefault();
        }
    }
    async sendForm() {
        if (!this.showThanks) {
            if (!this.order)
                return;
            this.loading = true;
            switch (this.methodPayment) {
                case PaymentMethod.CASH:
                    {
                        if (this.cashInfo != '') {
                            this.order.payment = PaymentMethod.CASH;
                            this.order.cash = this.cashInfo;
                            const paymentDetails = new PaymentDetails();
                            paymentDetails.status = PaymentStatus.PENDING_PAYMENT;
                            paymentDetails.amount = this.order.subtotal + this.order.deliveryCost;
                            paymentDetails.type = TypePayment.CASH;
                            this.order.paymentDetails = { ...paymentDetails };
                            this.$store.state.order.statusDelivery = StatusDelivery.FINISHED;
                        }
                        else {
                            this.cashInfoError = true;
                        }
                    }
                    break;
                case PaymentMethod.ONLINE:
                    {
                        this.order.payment = PaymentMethod.ONLINE;
                        this.$store.state.order.statusDelivery = StatusDelivery.FINISHED;
                    }
                    break;
            }
            const orderId = await OrderService.sendOrder(this.order, '', this.order.type, this.order.deliveryCost);
            if (orderId) {
                switch (this.methodPayment) {
                    case PaymentMethod.ONLINE:
                        {
                            try {
                                if (auth.currentUser) {
                                    const body = {
                                        orderId: orderId,
                                        cardId: this.token
                                    };
                                    const options = {
                                        headers: {
                                            Authorization: await auth.currentUser.getIdToken(true)
                                        }
                                    };
                                    const resp = await axios.post(`${process.env.VUE_APP_PAYMENT_USER}/api/v1/payment/stripe/order`, body, options);
                                    if (resp.data &&
                                        resp.data.paymentDetails &&
                                        resp.data.paymentDetails.status === 'SUCCEEDED') {
                                        this.order.id = resp.data.id;
                                        this.$store.commit('setOrder', this.order);
                                        this.$analytics.logEvent('purchase', {
                                            value: this.order.subtotal + this.order.deliveryCost,
                                            currency: this.order.currency,
                                            transaction_id: this.order.id,
                                            shipping: this.order.deliveryCost,
                                            payment_type: 'Online',
                                            items: this.order.items.map(item => ({
                                                item_id: item.id,
                                                item_name: item.name,
                                                quantity: item.quantity,
                                                price: Number(item.price),
                                                item_category: item.category,
                                                item_category2: item.subcategory,
                                                item_brand: this.$store.state.menu.name,
                                                affiliation: this.$store.state.typeOrder
                                            }))
                                        });
                                        this.$router.push('/SummaryDeliveryConfirm');
                                    }
                                }
                            }
                            catch (e) {
                                this.messageToPurchaser = ApiErrors.NOT_FINALIZED;
                                this.showDoubleConfirm = false;
                                this.hideModal = false;
                            }
                        }
                        break;
                    case PaymentMethod.CASH:
                        {
                            this.$store.commit('setOrder', this.order);
                            this.$router.push('/SummaryDeliveryConfirm');
                            this.$analytics.logEvent('purchase', {
                                value: this.order.subtotal + this.order.deliveryCost,
                                currency: this.order.currency,
                                transaction_id: this.order.id,
                                shipping: this.order.deliveryCost,
                                payment_type: 'Cash',
                                items: this.order.items.map(item => ({
                                    item_id: item.id,
                                    item_name: item.name,
                                    quantity: item.quantity,
                                    price: Number(item.price),
                                    item_category: item.category,
                                    item_category2: item.subcategory,
                                    item_brand: this.$store.state.menu.name,
                                    affiliation: this.$store.state.typeOrder
                                }))
                            });
                        }
                        break;
                }
            }
            this.loading = false;
        }
    }
    show(option) {
        switch (option) {
            case 'CASH':
                this.displayDivCash = true;
                this.displayDivTransfer = false;
                this.displayDivCard = false;
                this.displayDivConketa = false;
                break;
            case 'ONLINE':
                this.displayDivCash = false;
                this.displayDivTransfer = false;
                this.displayDivCard = true;
                break;
            default:
                break;
        }
    }
    reduceIngredients(ingredients, start) {
        return ingredients.reduce((p, i, index, array) => p +
            i.localizedNames +
            ': ' +
            i.extraIngredients.map(rest => {
                if (rest.selected == true)
                    return ' ' + rest.localizedNames;
            }) +
            `${index + 1 == array.length ? '' : ', ' + start + ' '}`, start + ' ');
    }
    changeAddress() {
        this.$router.push('/maps');
    }
    backToMenu() {
        this.$router.push('/menu');
    }
    async created() {
        this.loading = true;
        const request = await AddressService.getAllAddressBook();
        if (request) {
            const data = request.data;
            data.forEach(a => {
                if (a.defaultAddress) {
                    this.address = a.formatAddress;
                    this.addressDefault = true;
                    this.$store.state.order.address = a;
                    this.$store.state.order.address.location = new firebase.firestore.GeoPoint(a.location.lat, a.location.lng);
                }
            });
        }
        this.canOrder = await this.calculateDeliveryCost();
        if (this.user && this.order) {
            this.order.userId = this.user.id;
            this.order.name = this.user.name;
            this.order.email = this.user.email;
            this.order.phone = this.user.phone;
            this.order.type = TypeOrder.DELIVERY;
            this.order.statusDelivery = StatusDelivery.SUMMARY;
            this.order.number = OrderService.generateReadableId();
            this.order.status = 'PENDING';
        }
        if (this.order && !this.order.items.some(item => item.type == 'PRODUCT'))
            this.backToMenu();
        this.nameRestaurant = this.$store.state.menu.name;
        this.getInfoOrder();
        this.getTotal();
        if (this.order)
            this.order.total = this.order.subtotal + this.order.deliveryCost;
        if (this.paymentActive && this.conektaActive && this.onlinePaymentActive) {
            this.checkedTabs = true;
            this.loadStripe();
            this.methodPayment = 'ONLINE';
            this.show('ONLINE');
        }
        else {
            this.methodPayment = 'CASH';
            this.show('CASH');
            this.checkedTabs = false;
        }
        this.$store.commit('setOrder', this.order);
        this.loading = false;
    }
    async calculateDeliveryCost() {
        let locationUser = new firebase.firestore.GeoPoint(0, 0);
        const data = this.$store.state.order;
        if (data.address) {
            locationUser = this.$store.state.order.address.location;
        }
        else {
            locationUser = this.$store.state.deliveryMenu.location;
        }
        const locationCatalog = this.$store.state.deliveryMenu.location;
        return getDeliveryCost(locationUser, locationCatalog);
    }
    async successTokenHandler() {
        if (auth.currentUser) {
            try {
                const body = {
                    tokenId: this.token
                };
                const options = {
                    headers: {
                        Authorization: await auth.currentUser.getIdToken(true)
                    }
                };
                const resp = await axios.post(`${process.env.VUE_APP_PAYMENT_USER}/api/v1/payment/stripe/card`, body, options);
                if (resp.data && resp.data.id) {
                    if (this.order) {
                        this.$analytics.logEvent('add_payment_info', {
                            currency: this.order.currency,
                            payment_type: 'Stripe',
                            value: this.order.subtotal + this.order.deliveryCost,
                            items: this.order.items.map(item => ({
                                item_id: item.id,
                                item_name: item.name,
                                quantity: item.quantity,
                                price: Number(item.price),
                                item_category: item.category,
                                item_category2: item.subcategory,
                                item_brand: this.$store.state.menu.name,
                                affiliation: this.$store.state.typeOrder
                            }))
                        });
                    }
                    this.token = resp.data.id;
                    this.loading = false;
                    this.showDoubleConfirm = true;
                }
            }
            catch (error) {
                const data = error.response.data;
                const message = data.errors.shift().trim();
                if (Object.values(ApiErrors).includes(message)) {
                    const match = Object.entries(ApiErrors).find(([key, value]) => value === message);
                    if (match) {
                        const [key] = match;
                        this.messageToPurchaser = ApiErrors[key];
                    }
                    else {
                        this.messageToPurchaser = ApiErrors.NOT_FINALIZED;
                    }
                }
                this.showDoubleConfirm = false;
                this.hideModal = false;
            }
        }
    }
    errorTokenHandler(errorMessage) {
        if (this.order) {
            this.$analytics.logEvent('add_payment_info_error', {
                currency: this.order.currency,
                error_message: errorMessage,
                payment_type: 'Stripe',
                value: this.order.subtotal + this.order.deliveryCost,
                items: this.order.items.map(item => ({
                    item_id: item.id,
                    item_name: item.name,
                    quantity: item.quantity,
                    price: Number(item.price),
                    item_category: item.category,
                    item_category2: item.subcategory,
                    item_brand: this.$store.state.menu.name,
                    affiliation: this.$store.state.typeOrder
                }))
            });
        }
        this.messageToPurchaser = errorMessage;
        this.hideModal = false;
        this.loading = false;
    }
    async loadStripeScript() {
        const lang = this.$store.state.language === 'spanish' ? 'es-419' : 'en';
        if (!this.stripe)
            this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY || '', {
                locale: lang
            });
    }
    async getStripePaymentMethod() {
        if (this.stripe) {
            if (this.cardElement) {
                const result = await this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardElement
                });
                if (result.paymentMethod && result.paymentMethod.id) {
                    this.token = result.paymentMethod.id;
                    this.successTokenHandler();
                }
                else {
                    if (result.error && result.error.message)
                        this.errorTokenHandler(result.error.message);
                }
            }
        }
    }
    async loadStripe() {
        await this.loadStripeScript();
        if (auth.currentUser && this.stripe) {
            const options = {
                headers: {
                    Authorization: await auth.currentUser.getIdToken(true)
                }
            };
            try {
                const user = await axios.get(`${process.env.VUE_APP_PAYMENT_USER}/api/v1/payment/stripe`, options);
                if (user.data && user.data.id) {
                    const data = user.data;
                    this.customer = new Customer(data?.id, data?.name, data?.email, data?.object, data?.createdAt);
                }
            }
            catch {
                const newUser = await axios.post(`${process.env.VUE_APP_PAYMENT_USER}/api/v1/payment/stripe`, {}, options);
                if (newUser.data && newUser.data.id) {
                    const data = newUser.data;
                    this.customer = new Customer(data?.id, data?.name, data?.email, data?.object, data?.createdAt);
                }
                else {
                    this.stripeReady = false;
                }
            }
            if (!this.cardElement) {
                this.cardElement = this.stripe.elements().create('card');
                this.cardElement.mount('#card-element');
                this.cardElement.on('change', evt => {
                    this.completeForm = evt.complete;
                });
            }
        }
        else {
            this.stripeReady = false;
        }
    }
    getInfoOrder() {
        const payments = this.$store.state.deliveryMenu.payment;
        payments.cash ? (this.cashActive = true) : (this.cashActive = false);
        payments.online.active ? (this.onlineActive = true) : (this.onlineActive = false);
    }
    getTotal() {
        if (this.order) {
            if (this.$store.state.currency == 'MXN') {
                const total = this.order.subtotal + this.order.deliveryCost;
                this.totaltext = `${formatPrice(total)} MXN`;
            }
            else {
                let total = this.order.subtotal;
                const delivery = this.order.deliveryCost;
                const localizations = this.$store.state.menu.localizations;
                localizations.forEach((docLocalization) => {
                    if (docLocalization.currency == this.$store.state.currency) {
                        total = total * parseInt(docLocalization.change) + delivery;
                        this.totaltext = `${formatPrice(total)} MXN`;
                    }
                });
            }
        }
        else {
            this.totaltext = '';
        }
    }
};
SummaryDelivery = __decorate([
    Component({
        components: {
            CommonHeader,
            VariableLogo,
            Background,
            Thumbnail,
            CounterButton,
            BeeInput,
            Modal,
            AjaxButton,
            VueQrcode,
            WhatsApp,
            BlankLayout,
            ThankYouOrderModal,
            DoubleConfirmFinishOrder,
            SpinnerHolder,
            Snackbar
        }
    })
], SummaryDelivery);
export default SummaryDelivery;
